<template>
  <!-- Ad-boards (built with makeBoard): logos scroll along each board
       forever — two identical runs shifted by exactly one board length, so
       the loop has no seam. Must be used inside an <svg>. -->
  <g>
    <g v-for="b in boards" :key="b.key">
      <polygon :points="b.points" :fill="fill" />
      <polygon :points="b.top" :fill="topFill" />
      <g :transform="b.matrix">
        <clipPath :id="uid + 'clip-' + b.key">
          <polygon :points="b.clip" />
        </clipPath>
        <g :clip-path="'url(#' + uid + 'clip-' + b.key + ')'">
          <g>
            <animateTransform attributeName="transform" type="translate" :from="(-b.len) + ' 0'" to="0 0" :dur="b.dur + 's'" repeatCount="indefinite" />
            <template v-for="(x, i) in b.slots">
              <image v-if="logoUrl" :key="b.key + 'i' + i" :href="logoUrl" :x="x - logoW(b) / 2" :y="-b.h + 1" :width="logoW(b)" :height="b.h - 2" preserveAspectRatio="xMidYMid meet" />
              <text v-else :key="b.key + 't' + i" :x="x" :y="-b.h / 2 + 3.5" text-anchor="middle" class="sb-text">{{ boardText }}</text>
            </template>
          </g>
        </g>
      </g>
    </g>
  </g>
</template>

<script>
export default {
  name: 'ScrollingBoards',
  props: {
    boards: { type: Array, required: true },
    // Prefix for the clip-path ids (SVG ids are document-global).
    uid: { type: String, required: true },
    logoUrl: { type: String, default: '' },
    boardText: { type: String, default: 'LIVE' },
    fill: { type: String, default: '#1f4a3a' },
    topFill: { type: String, default: '#2c5c49' }
  },
  methods: {
    // Logo box: the whole board height and most of its slot, so a wide
    // logo is limited by the height (as big as the board allows).
    logoW(b) {
      return Math.max(b.item, b.slot * 0.85);
    }
  }
};
</script>

<style scoped>
.sb-text { font-family: Roboto, Arial, sans-serif; font-weight: 900; font-size: var(--font-size-md); fill: #fff; }
</style>
